import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ListContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._300,
    alignSelf: "stretch"
}));

export const ListItem = styled("li")(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.space._200,
    alignSelf: "stretch"
}));

export const ListNumber = styled(Typography)(({ theme }) => ({
    minWidth: theme.fontSizes["3xl"],
    color: theme.colors["pink.400"],
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights.base, 
    paddingLeft: theme.space._300
}));

export const ListContent = styled(Typography)(({ theme }) => ({
    flex: "1 0 0",
    color: theme.colors["neutral.500"],
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.base, 
}));